<template>
  <div class="last-updated-at" v-if="lastUpdatedAt">
    Data last updated<br />
    {{ lastUpdatedFormattedTime }}
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { dateTimezone } from '@/utils/filters';

export default {
  name: 'LastUpdatedAt',

  created() {
    this.fetch();
    this.updateIntervalId = setInterval(() => this.fetch(), 1000 * 600);
  },

  beforeDestroy() {
    if (this.updateIntervalId) {
      clearInterval(this.updateIntervalId);
      this.updateIntervalId = null;
    }
  },

  data() {
    return {
      updateIntervalId: null,
    };
  },

  computed: {
    ...mapGetters(['lastUpdatedAt', 'userTimezone']),

    lastUpdatedFormattedTime() {
      return dateTimezone(this.lastUpdatedAt, 'MMM D, YYYY [at] h:mma', this.userTimezone);
    },
  },

  methods: {
    ...mapActions({
      fetch: 'FETCH_LAST_UPDATED_AT',
    }),
  },
};
</script>

<style lang="scss" scoped>
.last-updated-at {
  align-self: flex-start;
  margin-top: 12px;
  padding: 0 16px;
}
</style>
